import { render, staticRenderFns } from "./PaymentRequisitionDetailFormDialog.vue?vue&type=template&id=0958ce84&"
import script from "./PaymentRequisitionDetailFormDialog.vue?vue&type=script&lang=ts&"
export * from "./PaymentRequisitionDetailFormDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports